import {  mutations as exchangeutations } from '@/code-lab/component/exchange/observable.js'
export default {
    methods: {
        unlockMoreMission$ () {
            exchangeutations.type('mission')
            if (!exchangeutations.isEmpty('mission')) return
            exchangeutations.mission({ show: true })
        }
    },
}